@for (i of [].constructor(count); track $index) {
  <div
    class="loading-card-holder"
    [class.animations-enabled]="animationEnabled"
    [ngClass]="type"
  >
    @if (type === "post") {
      <div class="post-type loading-card">
        <div class="top">
          <div class="img"></div>
          <div class="content">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </div>
        <div class="bottom">
          <div class="footer">
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
          </div>
        </div>
      </div>
    }
    @if (type === "post-gallery") {
      <div class="post-type gallery-loading-card">
        <div class="top">
          <div class="img"></div>
        </div>
        <div class="bottom">
          <div class="content">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div class="footer">
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
            <div class="placeholder-item"></div>
          </div>
        </div>
      </div>
    }
    @if (type === "widget") {
      <div class="widget-loading-card">
        <div class="tools">
          <div class="check"></div>
          <div class="title"></div>
          <div class="actions">
            <div class="action"></div>
            <div class="action"></div>
            <div class="action"></div>
            <div class="action"></div>
            <div class="action"></div>
            <div class="action"></div>
          </div>
        </div>
        <div class="content"></div>
      </div>
    }
    @if (type === "data-widget") {
      <div class="data-widget-loading-card">
        <div class="content"></div>
      </div>
    }
  </div>
}
